import React from 'react'
import {Button, Link} from 'startlibs/lib/components'
import {withToggles} from 'startlibs/lib/hocs'
import {connect} from 'react-redux'
import {DOBAuth} from './DOBAuth'
import {
  CardContent,
  CardIcon,
  SuccessIcon,
  DownloadLoading,
  PageCard,
  PageContainer,
  PageFooter,
} from './SharingComponents'
import dicomIcon from '../../../public/dicom-icon.svg'
import {withRouter} from 'react-router-dom'
import {LoadingUser} from '../App'
import {simpleFetch} from '../lib'

@withToggles('loading')
@connect(({user})=>({user}))
@withRouter
export class DownloadStudyPage extends React.PureComponent {

  state = {checked: false}

  componentDidMount() {
    if (!this.props.phiAuthenticationActive) {
      this.check()
    }
  }

  check = () => {
    simpleFetch(`/api/share/check/${this.getUUID()}`)
      .then(({studyInfo, sharingOptions, fileInfo}) => {
        this.setState({status: 'available', sharingOptions, studyInfo, fileInfo})
      })
      .catch(({status,...rest}) => {
        if (status === 424) {
          this.setState({status: 'uploading'})
          setTimeout(this.check, 30 * 1000)
        } else {
          this.setState({status: 'error'})
        }
      })
  }

  checkAndDownload = () => {
    this.setState({status: 'download'})
    simpleFetch(`/api/share/download/${this.getUUID()}`,{method:"HEAD"})
      .then(this.download)
      .catch(this.expired)
  }

  download = (patienParam) => {
    this.setState({status: 'finished'})
    const link = document.createElement('a')
    link.href = `/api/share/download/${this.getUUID()}?${patienParam}`
    link.setAttribute('download', '')
    link.click()
  }

  getUUID = () => this.props.match.params.uuid

  expired = () => this.setState({status: 'error'})

  render() {
    const {user} = this.props
    const {status, studyInfo, sharingOptions} = this.state
    //const status = 'finished'
    //const studyInfo = {patientName:'Bolsonaro'}
    //const sharingOptions = {dobCheck: true}
    return <PageContainer>
      <div className="navbar">
        <div className="navbar-content">
          <div className="left-container logo-container">
            {
              user.id ?
              <Link to="/" className="logo">Horos Cloud</Link> :
              <Link skipTo="/" className="logo">Horos Cloud</Link>
            }
          </div>
        </div>
      </div>
      <div></div>
      <PageCard>
        {
          status &&
          <CardIcon>
            <img alt="Dicom icon" src={dicomIcon}/>
          </CardIcon>
        }
        {
          !status ?
          <LoadingUser/> :
          status === 'uploading' ?
          <StudyUploading/> :
          status === 'error' ?
          <StudyNotFound/> :
          status === 'finished' ?
          <ThankYou studyInfo={studyInfo}/> :
          (status === 'available' || status === 'download') &&
            (sharingOptions.dobCheck ?
             <DOBAuth studyInfo={studyInfo} uuid={this.getUUID()} onSuccess={this.download} expired={this.expired}/> :
             <ConfirmDownload studyInfo={studyInfo} download={this.checkAndDownload} isDownloading={status === 'download'}/>
            )
        }
      </PageCard>
      <PageFooter>
        <a href="https://www.horosproject.org/">Horos</a> <a href="https://horoscloud.io/">Horos Cloud</a>
      </PageFooter>
    </PageContainer>
  }

}

const ConfirmDownload = ({studyInfo,download,isDowloading}) => <CardContent>
  <h2>Shared study details</h2>
  {studyInfo.patientName && <div className="patient-name">Patient: {studyInfo.patientName}</div>}
  <p className="main-text download-text">Click below to download the study.</p>
  <Button isLoading={isDowloading} highlight onClick={download}>Download study</Button>
</CardContent>

const StudyNotFound = () => <CardContent>
  <h2 className="error-title">Study expired or non-existent</h2>
  <p className="main-text">
    Study sharing links expire in 48 hours for security reasons.
  </p>
  <p>
    Plesae check if this is the correct link or reach out to the person who shared this study with you and ask for them to sharing again.
  </p>
</CardContent>

const StudyUploading = () => <CardContent>
  <h2>This study is still being uploaded</h2>
  <DownloadLoading size={60} borderWidth={8}/>
  <p className="main-text">Please wait, or come back later.</p>
</CardContent>

const ThankYou = ({studyInfo,retry}) => <CardContent>
  <h2>Your download will begin shortly</h2>
  {studyInfo.patientName && <div className="patient-name">Patient: {studyInfo.patientName}</div>}
  <SuccessIcon icon="check"/>
  <p className="main-text">If your download has not started automatically, <a onClick={retry} className="link">try again</a>.</p>
</CardContent>



// WEBPACK FOOTER //
// ./src/javascripts/shareModule/DownloadStudyPage.jsx